import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class UserMgr extends Base {
  // 新建用户
  public static addUser(param: object) {
    return request.post(`/api/user`, param);
  }
  // 删除用户
  public static deleteUser(userId) {
    return request.delete(`/api/user/${userId}`);
  }
}
